const { EncryptStorage } = require("encrypt-storage");
// const isProduction = process.env.NODE_ENV === "production";
const isProduction = false;
const storageSecret = process.env.VUE_APP_STORAGE_SECRET;

const resolveStorage = (type = "local") => {
  type = `${type}Storage`;

  if (isProduction) {
    return new EncryptStorage(storageSecret, {
      storageType: type
    });
  }

  return window[type];
};

export const getStorageData = (key, storageType) => {
  const storage = resolveStorage(storageType);
  const foundKey = storage.getItem(key);

  if (!foundKey) {
    return null;
  }

  try {
    let parsedKey = foundKey;

    if (!isProduction) {
      parsedKey = JSON.parse(foundKey);
    }

    return parsedKey;
  } catch (error) {
    // TODO: implement logger
    return null;
  }
};

export const removeStorageData = (key, storageType) => {
  const storage = resolveStorage(storageType);
  storage.removeItem(key);
};

export const setStorageData = (key, value, storageType) => {
  const storage = resolveStorage(storageType);
  try {
    if (typeof value !== "object") {
      throw new Error("The value must be an object");
    }

    storage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // TODO: add logger here
    console.error(error);
  }
};

export const clearStorageData = storageType => {
  const storage = resolveStorage(storageType);

  const ignoreKeys = ["intended"];

  for (var i = 0; i < storage.length; i++) {
    const key = storage.key(i);
    if (ignoreKeys.includes(key)) {
      continue;
    }

    storage.removeItem(key);
  }
};
